import { whatsappTemplateService } from "@/_services";
export const whatsappTemplate = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    metaList: {
      data: [],
      status: {},
    },
    entity: {
      data: [],
      status: {},
    },
    delete: {
      data: [],
      status: {},
    },
    update: {
      data: [],
      status: {},
    },
    post: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getWhatsappTemplatesRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getWhatsappTemplatesSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getWhatsappTemplatesError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    getMetaWhatsappTemplatesRequest(state) {
      state.metaList.status = {
        loading: true,
      };
    },
    getMetaWhatsappTemplatesSuccess(state, response) {
      state.metaList.data = response.data;
      state.metaList.status = {
        loaded: true,
      };
    },
    getMetaWhatsappTemplatesError(state, error) {
      state.metaList.data = [];
      state.metaList.status = {
        error,
      };
    },
    deleteWhatsappTemplateRequest(state) {
      state.delete.status = {
        deleting: true,
      };
    },
    deleteWhatsappTemplateError(state, error) {
      state.delete.data = null;
      state.delete.status = {
        error,
      };
    },
    deleteWhatsappTemplateSuccess(state, response) {
      state.delete.data = response;
      state.delete.status = {
        deleted: true,
      };
    },
    postWhatsappTemplateRequest(state) {
      state.post.status = {
        creating: true,
      };
    },
    postWhatsappTemplateError(state, error) {
      state.post.data = null;
      state.post.status = {
        error,
      };
    },
    postWhatsappTemplateSuccess(state, response) {
      state.post.data = response;
      state.post.status = {
        created: true,
      };
    },
    updateWhatsappTemplateRequest(state) {
      state.update.status = {
        updating: true,
      };
    },
    updateWhatsappTemplateError(state, error) {
      state.update.data = null;
      state.update.status = {
        error,
      };
    },
    updateWhatsappTemplateSuccess(state, response) {
      state.update.data = response;
      state.update.status = {
        updated: true,
      };
    },
    getWhatsappTemplateByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getWhatsappTemplateByIdError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    getWhatsappTemplateByIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
  },
  actions: {
    getWhatsappTemplates({ commit }, request) {
      commit("getWhatsappTemplatesRequest");
      whatsappTemplateService
        .getWhatsappTemplates(request.pagination, request.query)
        .then((response) => {
          commit("getWhatsappTemplatesSuccess", response);
        })
        .catch((error) => {
          commit("getWhatsappTemplatesError", error);
        });
    },
    getMetaWhatsappTemplates({ commit }) {
      commit("getMetaWhatsappTemplatesRequest");
      whatsappTemplateService
        .getMetaWhatsappTemplates()
        .then((response) => {
          commit("getMetaWhatsappTemplatesSuccess", response);
        })
        .catch((error) => {
          commit("getMetaWhatsappTemplatesError", error);
        });
    },
    deleteWhatsappTemplate({ commit }, id) {
      commit("deleteWhatsappTemplateRequest");
      whatsappTemplateService
        .deleteWhatsappTemplate(id)
        .then((res) => {
          commit("deleteWhatsappTemplateSuccess", res);
        })
        .catch((error) => {
          commit("deleteWhatsappTemplateError", error);
        });
    },
    postWhatsappTemplate({ commit }, request) {
      commit("postWhatsappTemplateRequest");
      whatsappTemplateService
        .postWhatsappTemplate(request)
        .then((res) => {
          commit("postWhatsappTemplateSuccess", res);
        })
        .catch((error) => {
          commit("postWhatsappTemplateError", error);
        });
    },
    updateWhatsappTemplate({ commit }, request) {
      commit("updateWhatsappTemplateRequest");
      whatsappTemplateService
        .updateWhatsappTemplate(request.id, request.body)
        .then((res) => {
          commit("updateWhatsappTemplateSuccess", res);
        })
        .catch((error) => {
          commit("updateWhatsappTemplateError", error);
        });
    },
    getWhatsappTemplateById({ commit }, id) {
      commit("getWhatsappTemplateByIdRequest");
      whatsappTemplateService
        .getWhatsappTemplateById(id)
        .then((res) => {
          commit("getWhatsappTemplateByIdSuccess", res);
        })
        .catch((error) => {
          commit("getWhatsappTemplateByIdError", error);
        });
    },
  },
};
